<template>
    <div class="components-container" id="mobileViewPort">
        <div id="mobileMode">
            <div id="queryArea">
                <div class="filter-container">
                    <div class="formItem">
                        <el-input v-model="queryForm.stuCode" placeholder="学号 / 姓名" clearable/>
                    </div>
                    <div class="formItem text-center">
                        <el-button @click="handleFilter" type="gray"><i class="el-icon-search"></i> 查询</el-button>
                        <el-button @click="handleReset" type="gray"><i class="el-icon-refresh"></i> 重置</el-button>
                        <el-button @click="queryDialogVisible = true" type="primary"><i class="el-icon-more"></i> 更多
                        </el-button>
                    </div>
                </div>
            </div>

            <!-- 搜索内容弹框 -->
            <el-dialog id="queryDialog" class="formDialog" title="查询信息" width="90%" :visible.sync="queryDialogVisible">
                <el-row>
                    <el-input v-model="queryForm.stuCode" placeholder="学号 / 姓名" clearable/>
                </el-row>
                <el-row>
                    <el-select v-model="queryForm.deptCode" filterable placeholder="系部" clearable
                               @change="changeOption('dept')">
                        <el-option v-for="item in comboOption.dept" :key="item.comboValue" :label="item.comboName"
                                   :value="item.comboValue"/>
                    </el-select>
                </el-row>
                <el-row>
                    <el-select v-model="queryForm.majorCode" filterable placeholder="专业" clearable
                               @change="changeOption('major')">
                        <el-option v-for="item in comboOption.major" :key="item.comboValue" :label="item.comboName"
                                   :value="item.comboValue"/>
                    </el-select>
                </el-row>
                <el-row>
                    <el-select v-model="queryForm.classCode" filterable placeholder="班级" clearable>
                        <el-option v-for="item in comboOption.class" :key="item.comboValue" :label="item.comboName"
                                   :value="item.comboValue"/>
                    </el-select>
                </el-row>
                <el-row>
                    <el-select v-model="queryForm.state" filterable placeholder="评阅状态" clearable>
                        <el-option v-for="item in comboOption.state" :key="item.comboValue" :label="item.comboName"
                                   :value="item.comboValue"/>
                    </el-select>
                </el-row>
                <div slot="footer" class="dialog-footer text-center">
                    <el-button type="gray" @click="handleFilter">查 询</el-button>
                    <el-button style="margin-left: 10px;" type="gray" @click="handleReset">重 置</el-button>
                    <el-button style="margin-left: 10px;" @click="queryDialogVisible = false">取 消</el-button>
                </div>
            </el-dialog>

            <div id="listArea" @scroll="handleScroll" :style="{'height': divHeight-110+'px','overflow': 'auto'}">
                <div v-if="tableData==null || tableData.length==0" class="cardTips">没有实习周记记录</div>
                <div class="cardMain" v-for="(item,index) in tableData" :key="index">
                    <div class="cardText">
                        <p><label for="">学&nbsp;&nbsp;&nbsp;&nbsp;号：</label>{{ item.stuCode }}</p>
                        <p><label for="">姓&nbsp;&nbsp;&nbsp;&nbsp;名：</label>{{ item.stuName }}</p>
                        <p><label for="">时间范围：</label>{{ timeRangeFormatter(item) }}</p>
                        <p><label for="">状&nbsp;&nbsp;&nbsp;&nbsp;态：</label>{{ stateFormatter(item) }}</p>
                    </div>
                    <div class="cardInput">
                        <el-button v-if="item.mark === '1'" type="warning" size="small" @click="open(item,'tea')">
                            评阅
                        </el-button>
                        <el-button v-if="item.mark === '0'" type="info" size="small" @click="open(item,'ins')">
                            查看
                        </el-button>
                    </div>
                </div>
                <div v-if="total>2 && total>tableData.length" id="loadingTips">
                    <i class="el-icon-loading"></i>&nbsp;信息加载中，请稍候...
                </div>
            </div>

            <el-dialog id="mainDialog" class="formDialog" :title="summaryDialogTitle" :visible.sync="summaryDialogVisible" v-if="summaryDialogVisible">
                <div id="infoDialogScroll" ref="infoDialogScroll" style="height: 73vh;overflow: auto">
                    <summarys ref="summary" :summaryForm="summaryForm" :summaryFlag="summaryFlag" :userCode="this.queryForm.userCode"
                              :scoreCombo="comboOption.wzcj" type="mobile" dialogWidth="90%"
                              :userType="userType" @callback="callback"/>
                </div>
            </el-dialog>

        </div>
    </div>
</template>

<script>
import {globalConfig} from "../../../../static/config";
import summarys from "../../../../src/views/postPracticeManage/summary";

export default {
    props: ['divHeight'],
    components: {
        summarys
    },
    data() {
        return {
            queryForm: {
                pageNum: 1,
                rowNum: 10,
                stuCode: '',
                deptCode: '',
                majorCode: '',
                classCode: '',
                userCode:'',
                userRoles:[],
            },
            //表格数据
            tableData: [],
            //选中行的数据
            selectRowData: null,
            tableLoading: true,
            total: null,
            currentPage: 1,
            mainTableHeight: 500,
            comboOption: {
                dept: [],
                major: [],
                class: [],
                wzcj: [],
                state:[
                    {'comboValue':'0','comboName':'未评阅'},
                    {'comboValue':'1','comboName':'已评阅'}
                ]
            },
            queryDialogVisible: false,
            detailDialogVisible: false,
            summaryForm:{
                id: '',
                stuName: '',
                className: '',
                unitName: '',
                postName: '',
                score: '',
                content1: '',
                content2: '',
                content3: '',
                submitState: '',
                stuCode: '',
                evaluate:''
            },
            summaryDialogTitle: '',
            summaryDialogVisible: false,
            summaryFlag: false,
            userType: '',
        }

    },
    mounted() {
        this.queryForm.userCode = this.userCode
        this.queryForm.userRoles = this.userRoles
        this.userInfo()
        this.initCombo()
    },
    methods: {
        callback() {
            this.requeryList()
            this.summaryDialogVisible = false
        },
        timeRangeFormatter(row){
            return row.time.replace('~', ' ~ ');
        },
        stateFormatter(rowData) {
            if (rowData.score == null) {
                return '未评阅'
            } else {
                return '已评阅'
            }
        },
        open(rowData, type) {
            this.summaryDialogTitle = rowData.stuName + '  ' + rowData.time.replace('~', ' ~ ')
            this.summaryForm.id = rowData.id
            this.summaryForm.stuName = rowData.stuName
            this.summaryForm.className = rowData.className
            this.summaryForm.score = rowData.score
            this.summaryForm.unitName = rowData.unitName
            this.summaryForm.postName = rowData.postName
            this.summaryForm.content1 = rowData.content1
            this.summaryForm.content2 = rowData.content2
            this.summaryForm.content3 = rowData.content3
            this.summaryForm.evaluate = rowData.evaluate
            this.userType = type
            this.summaryDialogVisible = true
        },
        userInfo() {
            this.$api.system.basic.userInfo({})
                .then((res) => {
                    this.queryForm.userCode = res.data.data.phone;
                    let arr = []
                    for (let roleCode in res.data.data.roles) {
                        if (roleCode === globalConfig.auth.admin || roleCode === globalConfig.auth.jwy_sx || roleCode === globalConfig.auth.fdy || roleCode === globalConfig.auth.sx_xbgly || roleCode === globalConfig.auth.sx_zyzdjs) {
                            arr.push(roleCode)
                        }
                    }
                    this.queryForm.userRoles = arr
                    // this.queryForm.userCode = '096136'
                    this.queryForm.userRoles = []
                    this.queryForm.userRoles.push(globalConfig.auth.jwy_sx)
                    // this.queryForm.userRoles.push('7')
                    // this.queryForm.userRoles.push('21')
                    this.queryList()
                }).catch((err) => {
                console.log(err);
            });
        },
        changeOption(type) {
            this.queryForm.classCode = ''
            let param = {}
            param = {
                "deptCode": this.queryForm.deptCode,
                "majorCode": this.queryForm.majorCode
            }

            if (type === 'dept') {
                this.queryForm.majorCode = ''
                this.$api.common.comboOption.major({
                    data: param
                }).then((res) => {
                    this.comboOption.major = res.data.data.comboData
                }).catch((err) => {
                    console.log(err);
                });
            }

            this.$api.common.comboOption.class({
                data: param
            }).then((res) => {
                this.comboOption.class = res.data.data.comboData
            }).catch((err) => {
                console.log(err);
            });
        },

        async queryList() {
            this.tableLoading = true;
            this.queryForm.pageNum = this.currentPage;

            await this.$api.postPracticeManage.weeklyReport.queryList({
                data: this.queryForm,
            }).then((response) => {
                this.total = response.data.data.total;
                this.tableData = this.tableData.concat(response.data.data.list);
                this.tableLoading = false;
            }).catch((error) => {
                this.tableLoading = false;
                console.log(error);
            });
        },
        initCombo() {
            this.$api.postPracticeManage.weeklyReport.initCombo({})
                .then((res) => {
                    this.comboOption.major = res.data.data.major
                    this.comboOption.grade = res.data.data.grade
                    this.comboOption.class = res.data.data.class
                    this.comboOption.dept = res.data.data.dept
                    this.comboOption.wzcj = res.data.data.wzcj
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        handleFilter() {
            this.requeryList();
            this.queryDialogVisible = false;
        },
        requeryList() {
            this.scrollToTop();
            this.tableData.length = 0;
            this.currentPage = 1;
            this.queryList();
        },
        scrollToTop() {
            const ele = document.getElementById('listArea');
            if (ele) {
                ele.scrollTop = 0;
            }
        },
        handleReset() {
            this.queryForm.stuCode = '';
            this.queryForm.deptCode = '';
            this.queryForm.majorCode = '';
            this.queryForm.classCode = '';
            this.queryForm.state = '';
            this.changeOption('dept')
            this.requeryList();
            this.queryDialogVisible = false;
        },
        handleScroll() {
            if (this.checkVisible() && !this.tableLoading && this.total > this.tableData.length) {
                this.currentPage++;
                this.queryList();
            }
        },
        checkVisible() {
            const ele = document.getElementById('loadingTips');
            if (ele) {
                let rect = ele.getBoundingClientRect();
                //获取当前浏览器的视口高度，不包括工具栏和滚动条
                let viewHeight = Math.max(document.documentElement.clientHeight, window.innerHeight);
                return !(rect.bottom < 0 || rect.top - viewHeight >= 0);
            } else {
                return false;
            }
        },
    }
}
</script>

<style src="styles/mobile.css"></style>
<style scoped>
#infoDialogScroll {
    height: 65vh;
    padding: 10px 20px;
}

#mobileMode {
    width: auto;
}

#mobileMode #queryDialog {
    top: 130px;
}

#mobileMode #loadingTips {
    height: 30px;
    line-height: 30px;
    color: #9d9d9d;
    position: relative;
    bottom: 0;
    text-align: center;
}
</style>



// WEBPACK FOOTER //
// summaryMobile.vue?33d5db16